import PropTypes from 'prop-types';
import { useState } from 'react';
import { ExpandMoreIcon } from '@/Components/Common/Icons';
import { HS_SELECT_POPUP_STYLE, StyledSelect } from './HSSelect.styles';

// antd Select with the shared HomeSight field look; all other Select props pass through.
export const HSSelect = ({ open, onOpenChange, suffixIcon, styles, ...rest }) => {
  const [innerOpen, setInnerOpen] = useState(false);
  const isOpen = open ?? innerOpen;

  const handleOpenChange = (nextOpen) => {
    setInnerOpen(nextOpen);
    onOpenChange?.(nextOpen);
  };

  return (
    <StyledSelect
      {...rest}
      open={open}
      onOpenChange={handleOpenChange}
      suffixIcon={
        suffixIcon ?? <ExpandMoreIcon className={`expand-icon ${isOpen ? 'rotate-180' : ''}`} />
      }
      styles={{
        ...styles,
        popup: { ...styles?.popup, root: { ...HS_SELECT_POPUP_STYLE, ...styles?.popup?.root } },
      }}
    />
  );
};

HSSelect.propTypes = {
  open: PropTypes.bool,
  onOpenChange: PropTypes.func,
  suffixIcon: PropTypes.node,
  styles: PropTypes.object,
};
